import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {ArenaGameFiltersCategoryEditor} from "../../arena-filters/categories/arena-game-filters-category-editor";
import {IAdvancedStrategyFiltersEditorViewModel} from "./advanced-strategy-filters-editor-view-model.interface";
import {IArenaGameFiltersCategory} from "../../arena-filters/categories/arena-game-filters-category.interface";
import {AdvancedFiltersAnalytics} from "./advanced-filters-analytics";
import {IAdvancedFiltersEditorToStrategyAdapter} from "./advanced-filters-editor-to-strategy-adapter";
import {
    IArenaGameFilterEditorViewModel
} from "../../arena-filters/filters/arena-game-filter-editor-view-model.interface";




export class AdvancedStrategyFiltersEditor implements IAdvancedStrategyFiltersEditorViewModel {
    constructor(private readonly strategy: IAdvancedFiltersEditorToStrategyAdapter,
                private readonly services: IServiceFactoryExtended) {

        this._categories = this.filtersCategories.map(c => new ArenaGameFiltersCategoryEditor(c));
        this.analyticsReporter = new AdvancedFiltersAnalytics(this.services);
    }

    readonly analyticsReporter: AdvancedFiltersAnalytics;

    get filtersCategories(): IArenaGameFiltersCategory[] {
        return this.strategy.filtersCategories;
    }

    private _categories: ArenaGameFiltersCategoryEditor[];
    get visibleCategories(): ArenaGameFiltersCategoryEditor[] {
        return this._categories.filter(c => c.visibleFilters.length > 0);
    }

    public getAppliedFiltersIds(): string[] {
        let result: string[] = [];

        this._categories.forEach(c => {
            result = [
                ...result,
                ...c.getAppliedFiltersIds()
            ];

        });
        return result;
    }



    getNumberOfGamesBeforeUserApply(): number {
        return this.services.gamesFilter.getNumberOfGamesBeforeUserApply(this.getAppliedFiltersIds());
    }

    openFilters(): void {
        this.analyticsReporter.reportOpenFilters();
    }

    private async _executeWithAnalyticsReporting(action: () => Promise<void>) {
        this.strategy.beginFilterAnalyticsReporting();
        await action();
    }

    async applyFilters(): Promise<void> {
        if(this.getAppliedFiltersIds().toString() !== this.services.gamesFilter.currentAppliedFiltersIds.toString()) {
            await this._executeWithAnalyticsReporting(async () => {
                await this.services.gamesFilter.applyFilters(this.getAppliedFiltersIds());
                this.analyticsReporter.reportApplyFiltersByButton(this.strategy.getApplyFilterReportingParameters());
            })

        }
    }

    async removeFilter(filter: IArenaGameFilterEditorViewModel): Promise<void> {
        filter.on = false;
        await this._executeWithAnalyticsReporting(async () => {
            await this.services.gamesFilter.applyFilters(this.getAppliedFiltersIds());
            this.analyticsReporter.reportRemoveFilter(filter.id);
        });
    }

    closeFilters() {
        this.services.drawer.right.back();
        this.analyticsReporter.reportCloseFilters();
    }

    async clearFilters(): Promise<void> {
        if(this.services.gamesFilter.isFilterOn) {
            await this._executeWithAnalyticsReporting(async () => {
                await this.services.gamesFilter.clearFilters();
                this.analyticsReporter.reportClearFilters();
            });
        }
        this.services.drawer.right.back();

    }
}